import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useModalStore } from '../../stores/useUIStore';
import apiClient from '../../api/api.js';
import toast from 'react-hot-toast';

const ProfessionalProfileConsentModal = ({ isOpen, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleAccept = async () => {
    setIsLoading(true);
    try {
      // 🟢 CORRECCIÓN: Llamamos al endpoint POST para crear explícitamente el perfil.
      await apiClient.post('/professional-profile');
      
      toast.success('¡Perfil creado! Ahora puedes completarlo.');
      
      // Cerramos el modal y redirigimos al usuario a la página de edición.
      onClose();
      navigate('/my-profile/professional');

    } catch (error) {
      toast.error('No se pudo crear el perfil. Inténtalo de nuevo.');
      console.error("Error al crear el perfil profesional:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
      <div 
        className="bg-white rounded-lg shadow-xl w-full max-w-md animate-fade-in-up"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6">
          <div className="text-center">
            <i className="fas fa-user-shield text-4xl text-blue-500 mb-4"></i>
            <h2 className="text-xl font-bold text-gray-800">Crear tu Perfil Profesional</h2>
            <p className="text-xs text-gray-800 rounded-md bg-yellow-100 p-2 mt-2">
              Al crear tu perfil profesional, aceptas que la información que compartas (como experiencia, educación y habilidades) pueda ser visible para empresas y reclutadores dentro de nuestra plataforma con el fin de conectarte con oportunidades laborales.
            </p>
            <p className="text-xs text-gray-500 mt-4">
              Podrás gestionar la visibilidad de tu perfil en cualquier momento.
            </p>
          </div>
        </div>

        <div className="px-6 py-4 bg-gray-50 border-t flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-semibold rounded-lg hover:bg-gray-200"
          >
            Cancelar
          </button>
          <button
            onClick={handleAccept}
            disabled={isLoading}
            className="px-4 py-2 text-sm font-semibold text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:bg-blue-400"
          >
            {isLoading ? 'Creando...' : 'Aceptar y Crear'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfessionalProfileConsentModal;